import Pocketbase from 'pocketbase'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { Modal, MODAL_TYPE } from './modal.jsx'
import { messages } from '../storageWorker/messages.js'
/*
TODO: Fix up sync:
- Test changelog sync
- On first login when there's no db, fetch all the data from the backend and insert
- On other logins, fetch all lists from both and compare updated dates and overwrite both
*/

// TODO: Focus inputs on show
// TODO: Clear inputs on LoginModal dismiss (useEffect on showModal)
// TODO: Fieldset for password change
// TODO: Add magic link URL params passed to access-ok root in the OTP email
// TODO: Reset PW dialog should become "Please check your email to complete resetting your password"
// TODO: Initial OTP login should go a bit differently -- show a message saying check your email, see if a verify flow is better, etc
// TODO: useTransition() to handle loading delay and other animations

function UserLoginChip({backend}) {
  const [email, setEmail] = useState('')
  const [loggedIn, setLoggedIn] = useState(false)
  const [otpId, setOtpId] = useState()
  const [modalType, setModalType] = useState()
  const [name, setName] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')
  const [user, setUser] = useState('')

  const broadcast = useMemo(() => new BroadcastChannel('cr-lists-storage'))
  const client = useMemo(() => new Pocketbase(backend), [backend])

  const refreshLoginState = () => {
    if (client.authStore.isValid) {
      setLoggedIn(true)
      setUser(client.authStore.record.name)
    }
  }

  useEffect(() => {
    refreshLoginState()
  }, [])

  const showLoginModal = (event) => {
    event.preventDefault()
    setModalType(MODAL_TYPE.LOGIN)
    setShowModal(true)
  }

  const handleLogout = (event) => {
    event.preventDefault()

    client.authStore.clear()
    setLoggedIn(false)
  }

  const handleRegister = async (event) => {
    event.preventDefault()
    setModalType(MODAL_TYPE.REGISTER)
    setShowModal(true)
  }

  // Handler to send POST request for user registration to the endpoint
  const handleRegisterSubmit = async ({ event, fieldData }) => {
    const { email, name, password, confirmed } = fieldData

    if (password != confirmed) {
      setError('Passwords must match.')
      return
    }

    // Construct the request
    const registerUrl = new URL('/register', client.baseURL)
    const options = {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...fieldData })
    }

    try {
      const response = await fetch(registerUrl.href, options)
      const data = await response.json()

      const { otpId } = data

      setName(name)
      setEmail(email)

      setOtpId(otpId)
      setModalType(MODAL_TYPE.ONE_TIME_PASSWORD)
    } catch (registerError) {
      setError(registerError.toString())

      console.error("There was an error registering:", error)
    }
  }

  const handleLoginSubmit = async ({ event, fieldData }) => {
    event?.preventDefault()

    const { email, password } = fieldData

    if (!email || !password) {
      setError('Please enter an email address and password')
      return
    }

    let authData
    try {
      authData = await client.collection('users').authWithPassword(email, password)
    } catch {
      setError('Incorrect email or password.')
      // TODO: clear password field
      return
    }

    const { record, token } = client.authStore

    // Success! Clear any errors, set the user, and clear the modal
    broadcast.postMessage({ type: messages.AUTH_UPDATED, record, token })
    refreshLoginState()
    setError('')
    setShowModal(false)
  }

  const handleOTPRequest = async ({ event }) => {
    const { otpId } = await client.collection('users').requestOTP(email)
    setOtpId(otpId)
  }

  const showResetPassword = async ({ event, fieldData }) => {
    setShowModal(true)
    setModalType(MODAL_TYPE.FORGOT_PASSWORD)
  }

  const handlePasswordResetRequest = async ({ event, fieldData }) => {
    const { email } = fieldData

    if (!email) {
      setError('Please enter an email')      
    }

    // TODO: Validate email?
    setError('')
    setEmail(email)
    await client.collection('users').requestPasswordReset(email)

    // TODO: Show success toast -- "Check your email, etc"

    setShowModal(false)
  }

  const handleOTPSubmit = async ({ event, fieldData }) => {
    event.preventDefault()

    const { password } = fieldData
    const authData = await client.collection('users').authWithOTP(otpId, password)
    if (!client.authStore.isValid) {
      setError('OTP code login unsuccessful!')
      console.error("Login unsuccessful!")
      return
    }

    const name = client.authStore.record.name

    setError('')
    setUser(name)
    setShowModal(false)
    setLoggedIn(true)
  }

  let actionCallback
  let resetCallback
  switch (modalType) {
    case MODAL_TYPE.LOGIN:
      actionCallback = handleLoginSubmit
      resetCallback = showResetPassword
      break

    case MODAL_TYPE.REGISTER:
      actionCallback = handleRegisterSubmit
      break

    case MODAL_TYPE.FORGOT_PASSWORD:
      actionCallback = handlePasswordResetRequest
      break

    case MODAL_TYPE.ONE_TIME_PASSWORD:
      actionCallback = handleOTPSubmit
      resetCallback = handleOTPRequest
      break
  }

  const cancelCallback = () => {
    setError('')
    setShowModal(false)
  }

	return <React.Fragment>
            <i role="presentation"
               aria-hidden="true"
               className="icon icon-profile"></i>
            <button className={`button is-text header-user-btn ${loggedIn ? 'is-hidden' : ''}`}
                    onClick={showLoginModal}>Login</button>
            <button className={`button is-text header-user-btn ${loggedIn ? 'is-hidden' : ''}`}
                    onClick={handleRegister}>Register</button>
            <span className={`header-user-name ${loggedIn ? '' : 'is-hidden'}`}>{ user }</span>
            <button className={`button is-text header-user-btn ${loggedIn ? '' : 'is-hidden'}`}
                    onClick={handleLogout}>Logout</button>
            <Modal type={modalType}
                    active={showModal}
                    actionCallback={actionCallback}
                    error={error}
                    cancelCallback={cancelCallback}
                    resetCallback={resetCallback}
                    />
          </React.Fragment>
}

document.addEventListener('DOMContentLoaded',() => {
  const el = document.getElementById('userChipRoot');
  const dataset = el.dataset;

  const backend = 'https://access-okeeffe.pockethost.io/'

  ReactDOM.createRoot(el).render(
      <React.StrictMode>
          <UserLoginChip backend={backend} />
      </React.StrictMode>)
})